module.exports = __webpack_public_path__ + "static/media/ma-2.729a6415.svg";